import { render, staticRenderFns } from "./TramiteConcluido.vue?vue&type=template&id=48498f1f&"
import script from "./TramiteConcluido.vue?vue&type=script&lang=js&"
export * from "./TramiteConcluido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports